import {Directive, Input, NgModule} from '@angular/core';
import {SdOption} from './option';

@Directive({
  selector: '[sdRipple], sd-ripple',
  standalone: true,
})
export class SdRipple {}

@Directive({
  selector: 'sd-optgroup',
  standalone: true,
})
export class SdOptgroup {}

export {SdOption} from './option';

@NgModule({
  imports: [SdRipple],
  exports: [SdRipple],
})
export class SdRippleModule {}

@NgModule({
  imports: [SdOption, SdOptgroup],
  exports: [SdOption, SdOptgroup],
})
export class SdOptionModule {}

@NgModule({
  imports: [SdRippleModule, SdOptionModule],
  exports: [SdRippleModule, SdOptionModule],
})
export class SdNativeDateModule {}

@NgModule({
  imports: [SdNativeDateModule, SdRippleModule, SdOptionModule],
  exports: [SdNativeDateModule, SdRippleModule, SdOptionModule],
})
export class SdCommonModule {}
